import React from "react";
import { cn } from "@/lib/utils";

const OPTIONS = [
  { id: "multiple_choice", label: "Multiple Choice", activeClass: "bg-info/10 text-info border-info/20" },
  { id: "free_response", label: "Free Response", activeClass: "bg-correct/10 text-correct border-correct/20" },
  { id: "true_false", label: "True or False", activeClass: "bg-premium/10 text-premium border-premium/20" },
  { id: "fill_blank", label: "Fill in the blank", activeClass: "bg-orange/10 text-orange border-orange/20" },
];

interface QuestionTypeSelectorProps {
  value: string[];
  onChange: (val: string[]) => void;
}

export const QuestionTypeSelector = ({
  value,
  onChange,
}: QuestionTypeSelectorProps) => {
  const toggle = (id: string) => {
    onChange(
      value.includes(id)
        ? value.filter((x) => x !== id)
        : [...value, id]
    );
  };

  return (
    <div className="p-1.5 rounded-2xl border border-primary/20 bg-card w-full">
      <div className="flex flex-wrap gap-1.5">
        {OPTIONS.map(({ id, label, activeClass }) => {
          const active = value.includes(id);

          return (
            <button
              key={id}
              type="button"
              onClick={() => toggle(id)}
              className={cn(
                "rounded-xl py-1.5 px-2 text-sm flex items-center gap-1.5 border transition-all duration-200",
                active
                  ? activeClass
                  : "bg-background text-muted-foreground border-secondary/10 hover:border-secondary/50 hover:text-foreground"
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
